import styled from '@xstyled/styled-components';

export const Select = styled.button`
  background-color: greyLight;
  padding: 11px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 300px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: 0.2s all linear;
  font: inherit;
  text-align: left;

  &:hover {
    background-color: greyMed;
  }

  &:focus-visible {
    outline: 2px solid var(--color-focus-ring);
    outline-offset: 2px;
  }

  svg {
    width: 15px;
    flex-shrink: 0;

    path {
      fill: #000000;
    }
  }
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: sm;
  color: black;

  span {
    font-size: xs;
    color: greyDark;
  }
`;

export const ModalBlock = styled.div`
  display: flex;
  background-color: white;
  position: relative;
  border-radius: 10px;

  @media (max-width: sm) {
    width: 100%;
  }
`;
